module.exports = __webpack_public_path__ + "static/media/2.14461b97.jpg";